<template>

    <div class="car_detail" v-model="car" v-on:keyup="carChangeKeyup">

    <header class="car_detail_header">
      <div class="car_vorgangsnummer">{{car.vorgangsnummer}}</div>
      <div class="car_date">{{ getFormattedDate(car) }} um {{car.usertime}}</div>

      <div class="car_detail_actions">
<!--
        <a href="#" class="button" title="Antworten"><i class="fa fa-reply" aria-hidden="true"></i></a>
        <a href="#" class="button" title="Weiterleiten" v-on:click="ShareMenuOpen"><i class="fa fa-share" aria-hidden="true"></i></a>

        <a href="#" v-on:click="deleteCar(car)" class="button" title="Löschen"><i class="fa fa-trash-o" aria-hidden="true"></i></a>				
-->
      </div>
    </header>

    <div class="car_detail_intern">
      <div class="columns">
        <div class="column">
          <label>Interne Anmerkungen</label>
          <notes-view :car.sync="car"></notes-view>
        </div>
      </div>
    </div>
    <div class="car_detail_information" >
      <div class="columns">
        <div class="column">

          <h3>Verkäufer</h3>
          <label><input v-model="car.name" v-on:focus="rememberOldValue($event.target.value)"  v-on:change="saveCarValue(car, 'name', $event.target.value)"><span>Verkäufer</span></label>
          <label><input v-model="car.telefonnummer" v-on:focus="rememberOldValue($event.target.value)"  v-on:change="saveCarValue(car, 'telefonnummer', $event.target.value)"><span>Telefon</span></label>
          <label><input v-model="car.e_mail" v-on:focus="rememberOldValue($event.target.value)"  v-on:change="saveCarValue(car, 'e_mail', $event.target.value)"><span>E-Mail</span></label>

          <label class="shorttext first"><input v-model="car.strasse" v-on:focus="rememberOldValue($event.target.value)" v-on:change="saveCarValue(car, 'strasse', $event.target.value)"><span>Straße</span></label><label class="shortnumber"><input v-model="car.hausnr" v-on:focus="rememberOldValue($event.target.value)" v-on:change="saveCarValue(car, 'hausnr', $event.target.value)"><span>Nr.</span></label> 
          <label class="shortnumber first"><input v-model="car.plz" v-on:focus="rememberOldValue($event.target.value)" v-on:change="saveCarValue(car, 'plz', $event.target.value)"><span>PLZ</span></label><label class="shorttext"><input v-model="car.stadt" v-on:focus="rememberOldValue($event.target.value)" v-on:change="saveCarValue(car, 'stadt', $event.target.value)"><span>Ort</span></label> 
          <label><input v-model="car.land" v-on:focus="rememberOldValue($event.target.value)"  v-on:change="saveCarValue(car, 'land', $event.target.value)"><span>Land</span></label>


          <hr>

          <h3>Schäden</h3>
          <ul>
            <li v-if="car.maengel_schaeden">{{car.maengel_schaeden}}</li>
            <li v-if="car.motorstartet > 0">{{getMotorStatus(car)}}</li>
            <li v-if="car.unfallfrei > 0">Unfallfrei: {{ getUnfallfrei(car) }}</li>
            <li v-if="car.nachlackierungen > 0">Nachlackierungen: {{ getNachlackierungen(car) }}</li>
            <li v-if="car.tuev">TÜV: {{car.tuev}}</li>

          </ul>
          <damages-view :car.sync="car"></damages-view>

        </div>
        <div class="column">
          <h3>Fahrzeug <span class="car_verkauf" v-if="car.verkauf == 'true' || car.kredit == 'true' ">{{car.verkauf == 'true'  ? 'steht zum Verkauf': ''}}{{car.kredit == 'true' && car.verkauf == 'true' ? ', ': ''}}{{car.kredit == 'true' ? 'finanziert':''}}</span></h3>
          <label><input class="u" v-model="car.marke" v-on:focus="rememberOldValue($event.target.value)"  v-on:change="saveCarValue(car, 'marke', $event.target.value)"><span>Marke</span></label>				
          <label><input class="u" v-model="car.modell" v-on:focus="rememberOldValue($event.target.value)"  v-on:change="saveCarValue(car, 'modell', $event.target.value)"><span>Modell</span></label>

          <div class="boxed">
          <label class="halfcol first"><input v-model="car.baujahr" v-on:focus="rememberOldValue($event.target.value)"  v-on:change="saveCarValue(car, 'baujahr', $event.target.value)"><span>Baujahr</span></label>
          <label class="halfcol last"><input v-model="car.kilometerstand" v-on:focus="rememberOldValue($event.target.value)"  v-on:change="saveCarValue(car, 'kilometerstand', $event.target.value)"><span>KM</span></label>
          </div>
          <div class="boxed">
            <label class="halfcol first"><input v-model="car.hubraum"><span>Hubraum</span></label><label class="halfcol"><input :value="getFuelType(car)" readonly><span>Kraftstoff</span></label>
          </div>

          <label><input v-model="car.standort" v-on:focus="rememberOldValue($event.target.value)"  v-on:change="saveCarValue(car, 'standort', $event.target.value)"><span>Standort</span><i v-if="car.standort != ''" v-on:click="openMapNewTap" class="fa fa-map-marker icon-right"></i></label>					

          <label><input class="u" v-model="car.vin" v-on:focus="rememberOldValue($event.target.value)"  v-on:change="saveCarValue(car, 'vin', $event.target.value)"><span>VIN</span></label>

          <hr>

          <div class="boxed">
            <label class="halfcol first"><input v-model="car.preisvorstellung" v-on:focus="rememberOldValue($event.target.value)"  v-on:change="saveCarValue(car, 'preisvorstellung', $event.target.value)"><span>Wunschpreis EUR</span><i class="fa fa-euro icon-right"></i></label>
            <label class="halfcol"><input v-model="car.datschwacke" v-on:focus="rememberOldValue($event.target.value)"  v-on:change="saveCarValue(car, 'datschwacke', $event.target.value)"><span>DAT EUR</span><i class="fa fa-euro icon-right"></i></label>
          </div>


          
          <label v-if="getDoorsId(car)"><input :value="getDoorsId(car)" readonly><span>Türen</span></label>
        </div>
      </div>
      <div class="columns" v-if="typeof car.fotos_json == 'object' && car.fotos_json.length > 0">
        <div class="column">			
          <h3>Fotos</h3>	
          <lightbox
                id="mylightbox"
                :images="images"
                :image_class=" 'img-responsive img-rounded' "
                :album_class=" 'my-album-class' "
                :options="options">
          </lightbox>	
<!--
          <ul class="fotolist">
            <li v-for="(foto, index) in car.fotos_json">	
              <img :src="foto" alt="">
            </li>
          </ul>
-->
        </div>
        <div class="column" v-if="car.Feedback">
          <h3>Feedback</h3>
          <p>{{car.Feedback}}</p>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <dat-info :car="car" :car.sync="car"></dat-info>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <h3>E-Mail-Kommunikation</h3>
          <cars-emails-view  :car="car"></cars-emails-view>
        </div>
      </div>

    </div><!-- /.car_detail_information -->

    <footer class="car_detail_footer">
      <div class="columns">
        <div class="column">
          <p class="metainfo">Referenz: {{car.aliasUrl}}<br>
            User-IP: {{car.userIP}}<br>
            User-Meta: {{car.userMetaData}}
          </p>
        </div>
      </div>
  </footer>


  </div><!-- /.car_detail -->
</template>

<script>
import DatInfo from '@/components/Dat/DatInfo';
import CarsEmailsView from '@/components/Cars/CarsEmailsView';
import NotesView from '@/components/Notes/NotesView';
import Lightbox from 'vue-simple-lightbox';
import DamagesView from '@/components/Damages/DamagesView';

export default {
	  
	components: {
      DatInfo,
      CarsEmailsView,
      NotesView,
      Lightbox,
      DamagesView
  },

    props: ['car'],
    data() {
      return {
        isEditing: false,
        FormattedDate: '',
        currentDate:  new Date(),
        yesterday: (function(d){ d.setDate(d.getDate()-1); return d})(new Date),
        oldValue: '',
//        carDetails: []    

		images : this.car.images , //[{ src: this.car.fotos_json[0], title: '' }],
          options : {
            closeText : '<i class="fa fa-close"></i>'
          }
       }
    },
/*
  sockets: {
      syncCarsDetails( carDetails ) {
      this.carDetails = carDetails;
      },
    },
*/


    watch: { 
      car: function (){
        console.log('car updated ' + this.car.vorgangsnummer);
      }
    },
    methods: {

      ShareMenuOpen: function(e){
        this.$store.state.accountContext = { account: $(e.currentTarget).attr('data-account'), accountID: $(e.currentTarget).attr('data-accountID') };			
        var self = this;
        $('#shareBox').toggleClass('open')
      },


      rememberOldValue(v){
      this.oldValue = v;
      },  
      saveCarValue(car, field, value){
      this.$socket.emit('saveCarValue', { update: { id: car.id, field: field, value: value, oldValue: this.oldValue }, quiet: 0 } );
      },  

      getDATinfo(){		  
        console.log('dat info clicked');
      },  

      openMapNewTap(){
        window.open('https://www.google.de/maps/place/' + encodeURI( this.car.standort ) );
      },

      carChangeKeyup: function(e){
      },

      carChanged: function(m,e, i){		 		  
      },  

      getFormattedDate(car){
        this.FormattedDate = car.userdate
        var d = new Date( car.created )
        if( d.toLocaleDateString() == this.currentDate.toLocaleDateString() )  return 'Heute'
        if( d.toLocaleDateString() == this.yesterday.toLocaleDateString() )  return 'Gestern'
        return this.FormattedDate
      },
      getNotes(car){
        return JSON.parse(car.notesstr)
      },
      getDamages(car){
        return JSON.parse(car.damagesstr)
      },

      getFotos(car){
      if( typeof car.fotos_json == 'object')
        if( car.fotos_json.length > 0) {
          console.log(car.fotos_json);
            return car.fotos_json;
        }
      return '';
      },
      getFuelType(car){
      if( car.kraftstoffart == '1') return 'Benzin';
      if( car.kraftstoffart == '2') return 'Diesel';
      if( car.kraftstoffart == '3') return 'Gas';
      if( car.kraftstoffart == '4') return 'andere';
      return '';
      },
      getDoorsId( car ){
      if( car.anzahltueren == '1') return 3;
      if( car.anzahltueren == '2' ) return 5;
      return '';
      },
      getMotorStatus(car){
      if( car.motorstartet == '1') return 'Motor startet';
      if( car.motorstartet == '2') return 'Motor startet nicht';
      if( car.motorstartet == '3') return 'Motor ist ausgebaut';
      return '';
      },

      getUnfallfrei( car ){
      if( car.unfallfrei == 1 ) return "ja";
      if( car.unfallfrei == 2 )  return "nein";
      if( car.unfallfrei == 3 )  return "nicht bekannt";
      return '';
    },

    getNachlackierungen( car ){
      if( car.nachlackierungen == 1 ) return "ja";
      if( car.nachlackierungen == 2 ) return "nein";
      if( car.nachlackierungen == 3 ) return "nicht bekannt";
      return 0;
    },
    
    deleteCar(car) {
        this.$emit('delete-car', car);
        },
    },
    mounted: function(){
      var self = this;
      this.$socket.emit('syncCarsDetails', {  } );
      if(!this.car.readby) {
        this.saveCarValue(this.car, 'readby', 1)
      }
    }
}
</script>




